module.exports = __webpack_public_path__ + "static/media/signature-large.f04d8094.png";